<div class="modal">
  <h2 class="h2 mb-0 align-center align-left--ps">Edit Custom ID</h2>
  <div class="mt-0100 d-flex">
    <div class="col">
      <mat-form-field class="w-100">
        <mat-label>{{data.entityCustomId.customIdType.label}}</mat-label>
        <input matInput
               placeholder="{{data.entityCustomId.customIdType.label}}"
               [(ngModel)]="data.entityCustomId.value">
      </mat-form-field>
    </div>
  </div>
  <div class="d-flex--ps flexJustify-between mt-0125">
    <button class="btn btn--whiteRed d-block w-100 w-auto--ps"
            (click)="close()"
            type="button">Cancel</button>
    <button class="btn btn--blue d-block w-100 w-auto--ps mb-0100 mb-0--ps"
            (click)="saveClicked()"
            [disabled]="isSaving"
            type="button">Save</button>
  </div>
</div>
